import { CalVer } from '~/utils/calver';
import { invariant } from '~/utils/invariant';

export let environment: 'development' | 'staging' | 'production';
export let version: string | undefined;

switch (process.env.CONTEXT) {
  case 'production':
    environment = 'production';
    break;

  case 'branch-deploy':
    environment = 'staging';
    break;

  case 'deploy-preview':
  case 'development':
    environment = 'development';
    break;

  default:
    if (process.env.NODE_ENV === 'development') {
      environment = 'development';
    } else {
      invariant(false, `Invalid context: "${process.env.CONTEXT}"`);
    }
}

const calVer = CalVer.fromString(process.env.VERSION ?? '');
invariant(
  environment === 'development' || calVer,
  `Invalid version in non-development environment: "${calVer}"`,
);
switch (environment) {
  case 'production':
    version = calVer?.toString();
    break;

  case 'staging':
    version = calVer
      ?.next()
      .withModifier(process.env.COMMIT_REF?.slice(0, 7) ?? '')
      .toString();
    break;

  case 'development':
    version = undefined;
    break;
}
